
namespace Riepiloghi.Negozio {

    @Serenity.Decorators.registerClass()
    export class RiepiloghiGrid extends Serenity.EntityGrid<RiepiloghiRow, any> {
        protected getColumnsKey() { return RiepiloghiColumns.columnsKey; }
        protected getDialogType() { return RiepiloghiDialog; }
        protected getIdProperty() { return RiepiloghiRow.idProperty; }
        protected getInsertPermission() { return RiepiloghiRow.insertPermission; }
        protected getLocalTextPrefix() { return RiepiloghiRow.localTextPrefix; }
        protected getService() { return RiepiloghiService.baseUrl; }

        private selectedItem: RiepiloghiRow = null;

        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            // need to register this plugin for grouping or you'll have errors
            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('Venduto'),
                    new Slick.Aggregators.Sum('Vecchio'),
                    new Slick.Aggregators.Sum('Liquidi'),
                    new Slick.Aggregators.Sum('Pos'),
                    new Slick.Aggregators.Sum('Resta'),
                    new Slick.Aggregators.Sum('Boutique'),
                    new Slick.Aggregators.Sum('Albergo'),
                    new Slick.Aggregators.Sum('Totale')
                ]
            });

            new Serenity.AutoColumnWidthMixin({
                grid: this,
                autoSizeAllJustOnce: true,
                useExplicitWidths: true,
                ignoreHeaders: 800,
                maxWidth: 800,
                minWidth: 400
            });

            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());

            return this.slickGrid;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            new Serenity.DraggableGroupingMixin({
                grid: this
            });

            new Serenity.CustomSummaryMixin({
                grid: this
            });
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true;
            opt.showFooterRow = true;
            return opt;
        }

        protected createQuickSearchInput() { }

        protected usePager() {
            return false;
        }

        protected getAddButtonCaption() {
            return "Aggiungi riepilogo";
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            //Remove a Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            //Add a Button
            buttons.push({
                title: 'Raggruppa per nominativo',
                hint: '',
                cssClass: 'expand-all-button',
                separator: true,
                onClick: () => this.view.setGrouping(
                    [{
                        getter: 'Nominativo'
                    }])
            });

            //Add a Button
            buttons.push({
                title: 'Raggruppa per data',
                hint: '',
                cssClass: 'expand-all-button',
                separator: true,
                onClick: () => this.view.setGrouping(
                    [{
                        getter: 'Data'
                    }])
            });

            //Add a Button
            buttons.push(Serenity.Extensions.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: this.getService() + '/ListExcel',
                separator: true,
                hint: "Esporta in Excel",
                title: "Esporta in Excel"
            }));

            //
            return buttons;
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number): void {

            // let base grid handle clicks for its edit links
            super.onClick(e, row, cell);

            // if base grid already handled, we shouldn"t handle it again
            if (e.isDefaultPrevented()) {
                return;
            }

            // get reference to current item
            var item = this.itemAt(row);

            //
            Q.notifyInfo(item.Data);

            //
            this.selectedItem = item;
        }
    }
}